import type { TimelineBlock } from "@/types/blocks";

const DOT_TONE = {
  neutral: "bg-muted-foreground",
  positive: "bg-success",
  negative: "bg-destructive",
  warning: "bg-warning",
} as const;

/** An entity's event history — a vertical rail of timestamped events. */
export function TimelineBlockView({ block }: { block: TimelineBlock }) {
  return (
    <div className="rounded-md border border-border bg-card p-3">
      {block.title && (
        <p className="mb-2 text-sm font-medium text-foreground">{block.title}</p>
      )}
      <ol className="flex flex-col gap-3">
        {block.events.map((ev, i) => (
          <li key={i} className="flex gap-3">
            <span className={`mt-1 h-2 w-2 shrink-0 rounded-full ${DOT_TONE[ev.tone]}`} />
            <div className="flex flex-col gap-0.5">
              <span className="text-xs text-muted-foreground">{ev.timestamp}</span>
              <span className="text-sm text-foreground">{ev.title}</span>
              {ev.detail && <span className="text-sm text-muted-foreground">{ev.detail}</span>}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
